import { parse } from 'papaparse'
import type { ParseConfig } from 'papaparse'

/**
 * Shared PapaParse configuration for CSV file parsing.
 *
 * Header transform: strips quotes, converts spaces to underscores, lowercases.
 * This is shared between the bulk upload feature and the migration assistant.
 */
export const SHARED_CSV_CONFIG: Partial<ParseConfig> = {
  header: true,
  skipEmptyLines: true,
  quoteChar: '"',
  escapeChar: '"',
  delimitersToGuess: [',', ';'],
  transformHeader: (header: string) =>
    header.replace(/"/g, '').replace(/ /g, '_').toLowerCase(),
}

/**
 * Parse a CSV file using the shared configuration.
 * Returns a promise that resolves with the parsed data.
 */
export function parseCsvFile<T>(
  file: File,
  overrides?: Partial<ParseConfig<T>>,
): Promise<{ data: T[]; headers: string[] }> {
  return new Promise((resolve, reject) => {
    parse<T>(file, {
      ...SHARED_CSV_CONFIG,
      ...overrides,
      complete: (result) => {
        resolve({
          data: result.data,
          headers: result.meta.fields ?? [],
        })
      },
      error: (error) => {
        reject(error)
      },
    })
  })
}
